// data shared in components: SortDropdown
import * as filtersSetters from './store/filters-setters'
import * as searchSetters from './store/searchStore-setters'
import * as dateFiltersSetters from './store/date-filters-setters'
import * as dateFiltersGetters from './store/date-filters-getters'
import * as search from './search'

const setFilters = (filters, filterName) => {
  // sets new filter
  filtersSetters.setFilterParams({
      "name": filterName,
      "filters": filters
    })

  // set number of items per page to default
  searchSetters.resetRows()
  // set page start to default
  searchSetters.resetPageStart()

  // if date filter is set
  if (dateFiltersGetters.getIsDate()) {
    // load results with new filter without changing date range
    search.loadResultsWithDataPreloadAlt()
  } else {
    // loads results with new filter with default date
    search.loadResultsWithDataPreload()
  }
  
  //reset date array for back button
  dateFiltersSetters.resetDateArr()
}

const resetFilters = () => {
  // reset filters in store
  filtersSetters.resetFilterParams()
}

export {
  setFilters,
  resetFilters
}



// WEBPACK FOOTER //
// ./src/scripts/modules/filter.js